import { selectActiveEnvironmentId, useScopeStore } from "./scopeStore";

/**
 * The active environment id, backed by the persisted scope store: each tenant
 * remembers its own sandbox selection across reloads (see scopeStore.ts).
 * null = the tenant's live environment (the server's default).
 */
export function getActiveEnvironmentId(): string | null {
  return selectActiveEnvironmentId(useScopeStore.getState());
}

export function setActiveEnvironment(id: string | null) {
  useScopeStore.getState().setActiveEnvironment(id);
}

/** Select a tenant's environment before navigating into it (see scopeStore.ts). */
export function setEnvironmentForTenant(tenantId: string, id: string | null) {
  useScopeStore.getState().setEnvironmentForTenant(tenantId, id);
}

export function useActiveEnvironmentId(): string | null {
  return useScopeStore(selectActiveEnvironmentId);
}
